import { APP_ID, ApplicationConfig, importProvidersFrom } from '@angular/core';

import { environmentFactory } from '@environment';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HomeModule } from '@app/home-page/home-page.module';
import { AuthenticationModule } from '@app/modules/authentication/authentication.module';
import { StorageService } from '@app/core/services/util/storage.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { PlatformService } from '@app/core/services/util/platform.service';
import { HttpInterceptorService } from '@app/core/services/http-interceptor.service';
import { DeviceService } from '@app/core/services/util/device.service';
import { ThirdPartyScriptService } from '@app/core/services/third-party-script/third-party-script.service';
import { GtmService } from '@app/core/services/analytics/gtm.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { DuplicateRequestInterceptor } from '@app/core/services/duplicate-request-interceptor.service';

export const baseAppConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(HomeModule, AuthenticationModule),
        StorageService,
        DatePipe,
        PlatformService,
        CurrencyPipe,
        { provide: APP_ID, useValue: 'box8App' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DuplicateRequestInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true
        },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { enterAnimationDuration: 0, exitAnimationDuration: 0 } }, //for giving default style for all dialog
        { provide: 'app-environment', useFactory: environmentFactory },
        { provide: 'app-storage-service', useClass: StorageService },
        { provide: 'app-device-service', useClass: DeviceService },
        { provide: 'app-platform-service', useClass: PlatformService },
        { provide: 'app-third-party-service', useClass: ThirdPartyScriptService },
        { provide: 'app-gtm-service', useClass: GtmService },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi())
    ]
};
